import Layout from '@/components/layout/Layout.vue';

const Login = resolve => require(['@/views/login/index'], resolve); //登入页
const Index = resolve => require(['@/views/home/index'], resolve);

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            requireAuth: true,
            hidden: true,
            title: '登录',
        }
    },
    {
        path: '/demand',
        name: 'demand',
        component: Layout,
        redirect: 'noredirect',
        meta: {
            requireAuth: true,
            title: '需求管理'
        },
        children: [
            {
                path: 'index',
                name: 'index',
                component: () =>
                    import('@/views/demand/index'),
                meta: {
                    title: '需求列表',
                    icon: 'dashboard',
                    keepAlive: true
                }
            },
            {
                path: 'demand-cooperation-list',
                name: 'demand-cooperation-list',
                component: () =>
                    import('@/views/demand/demand-cooperation-list'),
                meta: {
                    title: '合作意向列表',
                    icon: 'dashboard',
                    keepAlive: false
                }
            },
            
        ]
    },
    {
        path: '/supply',
        name: 'demand',
        component: Layout,
        redirect: 'noredirect',
        meta: {
            requireAuth: true,
            title: '供应管理'
        },
        children: [
            {
                path: 'index',
                name: 'index',
                component: () =>
                    import('@/views/supply/index'),
                meta: {
                    title: '供应列表',
                    icon: 'dashboard',
                    keepAlive: true
                }
            },
            {
                path: 'contract-list',
                name: 'contract-list',
                component: () =>
                    import('@/views/supply/contract-list'),
                meta: {
                    title: '联系记录列表',
                    icon: 'dashboard',
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: '/user',
        name: 'demand',
        component: Layout,
        redirect: 'noredirect',
        meta: {
            requireAuth: true,
            title: '用户管理'
        },
        children: [
            {
                path: 'index',
                name: 'index',
                component: () =>
                    import('@/views/user/index'),
                meta: {
                    title: '用户列表',
                    icon: 'dashboard',
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: '/property',
        name: 'demand',
        component: Layout,
        redirect: 'noredirect',
        meta: {
            requireAuth: true,
            title: '资产评估'
        },
        children: [
            {
                path: 'index',
                name: 'index',
                component: () =>
                    import('@/views/property/index'),
                meta: {
                    title: '资产评估列表',
                    icon: 'dashboard',
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: '/cooperation',
        name: 'demand',
        component: Layout,
        redirect: 'noredirect',
        meta: {
            requireAuth: true,
            title: '合作意向'
        },
        children: [
            {
                path: 'index',
                name: 'index',
                component: () =>
                    import('@/views/cooperation/index'),
                meta: {
                    title: '合作意向列表',
                    icon: 'dashboard',
                    keepAlive: true
                }
            }
        ]
    },
    // 导出管理
    {
        path:'/export',
        component: Layout,
        redirect: 'noredirect',
        children:[{
            path: 'export-list',
            name: 'export-list',
            component: () =>import('@/views/export/export-list'),
            meta: {
                title: '导出列表',
                icon: 'dashboard',
                keepAlive: true
            },
        }]
    },
    {
        path: '/404',
        component: () =>
            import('@/views/common/404.vue'),
        hidden: true
    },
    {
        path: '*',
        redirect: '/demand/index',
        hidden: true
    }

]
